import * as Dialog from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/**
 * «Hai modifiche non salvate»: the console's centred confirmation dialog, with two named buttons,
 * for leaving the capture page through «Chiudi» or «Annulla» (decision 182, U10).
 */
export function LeaveDialog({
  onStay,
  onLeave,
}: {
  readonly onStay: () => void;
  readonly onLeave: () => void;
}) {
  const { t } = useTranslation('expenses-detail');
  return (
    <Dialog.Root open onOpenChange={(next) => (next ? undefined : onStay())}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-[var(--scrim)]" />
        <Dialog.Content className="border-border bg-card fixed top-1/2 left-1/2 z-50 grid w-[min(26rem,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl border p-6 shadow-lg">
          <Dialog.Title className="text-foreground text-lg font-semibold">
            {t('leave.title')}
          </Dialog.Title>
          <Dialog.Description className="text-muted-foreground text-sm">
            {t('leave.body')}
          </Dialog.Description>
          <div className="flex flex-wrap justify-end gap-2">
            <Button type="button" variant="outline" className="min-h-11" onClick={onStay}>
              {t('leave.stay')}
            </Button>
            <Button type="button" className="min-h-11" onClick={onLeave}>
              {t('leave.leave')}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
